// 2026-09-12: 足/兜を接触絵へ合わせた実機px補正。元PNGの不透明bboxから穂先を測定。
// scaleFix は 兜頂点→靴底=137.33px / (216*.387/sqrt(alpha>16の面積))。
export const KNIGHT_SWEEP_ART: Record<string, {
  scaleFix: number; shiftX: number; tip?: readonly [number, number]
  tail?: readonly [number, number]; phase?: 'telegraph' | 'active'; at?: number
}> = {
  lanceSweep_turn: { scaleFix: 1.086179, shiftX: 11, tip: [0.633257, 0.001417], tail: [30, 30], phase: 'telegraph', at: 0.8 },
  lanceSweep_cut: { scaleFix: 1.073575, shiftX: -15, tip: [0.00092, 0.000956], tail: [48, -22], phase: 'telegraph', at: 0.92 },
  lanceSweep_ready: { scaleFix: 1.002249, shiftX: -9 },
  lanceSweep_contact: { scaleFix: 1, shiftX: 0, tip: [0, 292 / 929], tail: [13, -42], phase: 'active', at: 0 },
  // Ratio to lanceSweep_contact: 190 source helmet px divided by each new helmet height.
  leap_swing: { scaleFix: 1.0391414077107903, shiftX: 0 },
  scrape_stop: { scaleFix: 1.0093973189054506, shiftX: 0 },
  charge_run1: { scaleFix: 0.9949147808375374, shiftX: 0 },
  charge_run2: { scaleFix: 0.9520191571353281, shiftX: 0 },
}

// 槍の絵が切り替わった瞬間にだけ短い通過跡を残す。
// 先端は絵の穂先から動かさない。構え直し・中断・寿命後は描かない。
export function knightSweepTrailAlpha(image: string, phase: string, elapsedMs: number, chargeMs: number): number {
  const art = KNIGHT_SWEEP_ART[image]
  if (!art?.tip || phase !== art.phase || !Number.isFinite(elapsedMs)) return 0
  const age = elapsedMs - (phase === 'telegraph' ? chargeMs * art.at! : 0)
  const life = phase === 'active' ? 120 : Math.min(70, chargeMs * (image === 'lanceSweep_turn' ? 0.12 : 0.08))
  if (age < -1e-6 || age >= life || life <= 0) return 0
  return 0.72 * Math.pow(1 - Math.max(0, age) / life, 1.6)
}
